class PageAnchors {
  private items: NodeListOf<HTMLElement>;
  private sections: HTMLElement[];
  private activeClass: string = 'active';
  private headerOffset: number = 160; // Hauteur du header fixe

  constructor() {
    this.items = document.querySelectorAll('.page-anchors__aside-item');
    this.sections = Array.from(document.querySelectorAll('.page-anchors__content-inner > section'));
    this._init();
  }

  private _init(): void {
    // Initialiser l'état actif au chargement
    this._updateActiveAnchor();

    // Écouter les clics sur les liens
    this.items.forEach(item => {
      const link = item.querySelector('a');
      if (link) {
        link.addEventListener('click', e => this._handleClick(e));
      }
    });

    // Observer le scroll
    // this._observeScroll();
  }

  private _observeScroll(): void {
    // Utiliser Intersection Observer pour une meilleure performance
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            this._updateActiveAnchorById(id);
          }
        });
      },
      {
        rootMargin: `-${this.headerOffset}px 0px 0px 0px`,
        threshold: 0.1,
      }
    );

    // Observer chaque section
    this.sections.forEach(section => observer.observe(section));
  }

  private _updateActiveAnchorById(id: string): void {
    this.items.forEach(item => {
      const link = item.querySelector('a');
      if (!link) return;

      const itemHash = link.getAttribute('href')?.replace('#', '');

      if (itemHash === id) {
        item.classList.add(this.activeClass);
        // Mettre à jour l'URL sans déclencher de scroll
        window.history.replaceState(null, '', `#${id}`);
      } else {
        item.classList.remove(this.activeClass);
      }
    });
  }

  private _updateActiveAnchor(): void {
    const hash = window.location.hash.replace('#', '');

    if (!hash && this.items.length > 0) {
      // Si pas d'ancre, activer la première section
      const firstItem = this.items[0];
      firstItem.classList.add(this.activeClass);
      return;
    }

    this._updateActiveAnchorById(hash);
  }

  private _handleClick(e: Event): void {
    const link = e.currentTarget as HTMLAnchorElement;
    const targetId = link.getAttribute('href')?.replace('#', '');

    if (!targetId) return;

    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      e.preventDefault();
      const targetPosition = targetElement.offsetTop - this.headerOffset;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
      this._updateActiveAnchorById(targetId);
    }
  }
}

const pageAnchors = new PageAnchors();
